import SecRoute from "./SecRoute";

export default SecRoute